import {
  Box,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  useMediaQuery,
} from "@material-ui/core";
import { useTheme } from "@material-ui/styles";
import { assetIds, InputDate, ThemedAsset } from "nemuru-components";
import React, { useContext } from "react";
import { Controller, useForm } from "react-hook-form";
import { ICON_TITLE_HEIGHT } from "../../../../../config/config";
import IconTitle from "../../../../shared/components/IconTitle";
import MainButton from "../../../../shared/components/MainButton";
import Text from "../../../../shared/components/Text";
import { ConfigContext } from "../../../../../contexts/ConfigContext";
import { validateKeyboardInputDate } from "../../../../../utils/validations";
import { ProcessContext } from "../../../../../contexts/ProcessContext";
import { docIdTypes } from "../../shared/config";
import { SPANISH_NATIONALITY } from "../constants/SpanishNationality";
import { useNationalities } from "../../../../../utils/hooks/useNationalities/useNationalities";

export default function ManualIdentificationDataBirthInfo({
  onSubmitForm,
  data,
}) {
  const {
    state: { documentType },
  } = useContext(ProcessContext);
  const {
    state: { dictionaryValues },
  } = useContext(ConfigContext);

  const { palette, breakpoints } = useTheme();
  const isMobile = useMediaQuery(breakpoints.down("xs"));

  const { nationalities } = useNationalities();

  const { register, getValues, handleSubmit, errors, control } = useForm({
    defaultValues: {
      birthdate: data?.birthdate || null,
      birthCity: data?.birthCity,
      birthProvince: data?.birthProvince,
      nationality:
        !data?.documentExpeditor || documentType === docIdTypes.PASSPORT
          ? null
          : data?.documentExpeditor
          ? data?.documentExpeditor
          : SPANISH_NATIONALITY,
    },
  });

  const now = new Date();
  const minimumBirthDate = now.setFullYear(now.getFullYear() - 18);

  return (
    <>
      <Box className="appear-anim">
        <IconTitle
          icon={
            <ThemedAsset
              id={assetIds.ICON_ID_FRONT}
              width={ICON_TITLE_HEIGHT}
              height={ICON_TITLE_HEIGHT}
              style={{ color: palette.secondary.main }}
            />
          }
          title={<Text tId="ID" />}
          subtitle={<Text tId="BIRTH_DATA" />}
        />
        <InputDate
          allowKeyboardPicking={!isMobile}
          locale={dictionaryValues["DATE_LOCALE"]}
          emptyLabel={dictionaryValues["DATE_FORMAT_DAY_MONTH_YEAR"]}
          control={control}
          fullWidth
          variant="inline"
          openTo="year"
          autoOk
          views={["year", "month", "date"]}
          format="dd/MM/yyyy"
          label={<Text tId="BIRTHDATE" />}
          id="birthdate"
          name="birthdate"
          error={errors.birthdate ? true : false}
          helperText={errors.birthdate?.message}
          disableFuture={true}
          maxDate={minimumBirthDate}
          rules={{
            required: {
              value: true,
              message: <Text tId={"REQUIRED_FIELD"} />,
            },
            validate: {
              validate: (value) =>
                validateKeyboardInputDate({
                  value,
                  disableFuture: true,
                  maxDate: minimumBirthDate,
                }),
            },
          }}
        />
        <TextField
          fullWidth
          label={<Text tId={"BIRTH_CITY"} />}
          placeholder="Bilbao"
          type="text"
          id="birthCity"
          name="birthCity"
          error={errors.birthCity ? true : false}
          helperText={errors.birthCity?.message}
          inputProps={{
            ref: register({
              required: {
                value: true,
                message: <Text tId={"REQUIRED_FIELD"} />,
              },
            }),
          }}
        />
        <TextField
          fullWidth
          label={<Text tId={"BIRTH_PROVINCE"} />}
          placeholder="Vizcaya"
          type="text"
          id="birthProvince"
          name="birthProvince"
          error={errors.birthProvince ? true : false}
          helperText={errors.birthProvince?.message}
          inputProps={{
            ref: register({
              required: {
                value: true,
                message: <Text tId={"REQUIRED_FIELD"} />,
              },
            }),
          }}
        />
        <FormControl fullWidth>
          <InputLabel id="nationality">
            <Text tId="NATIONALITY" />
          </InputLabel>
          <Controller
            name="nationality"
            control={control}
            rules={{
              required: {
                value: true,
                message: <Text tId={"REQUIRED_FIELD"} />,
              },
            }}
            render={(props) => (
              <>
                <Select
                  MenuProps={{
                    MenuListProps: {
                      "aria-label": "Select nationality",
                    },
                  }}
                  onChange={(e) => props.onChange(e.target.value)}
                  value={props.value}
                  error={errors.nationality ? true : false}
                >
                  {nationalities.map((type, index) => (
                    <MenuItem key={index} value={type.value}>
                      {type.label}
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText style={{ color: palette.error.main }}>
                  {errors.nationality?.message}
                </FormHelperText>
              </>
            )}
          />
        </FormControl>
      </Box>
      <Box>
        <MainButton onClick={handleSubmit(() => onSubmitForm(getValues()))} />
      </Box>
    </>
  );
}
